var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "step-4" }, [
    _vm.careerLevelEligible ? _c("h1", [_vm._v(_vm._s(_vm.title))]) : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "tag-sections" }, [
      _vm.careerLevelEligible
        ? _c(
            "section",
            { staticClass: "tag" },
            [
              _c("LockInfo", { staticClass: "mb-3" }),
              _vm._v(" "),
              _c("CharacteristicSelectInline", {
                attrs: {
                  "characteristic-items": _vm.meta.careerLevel,
                  "initial-amount": 9,
                  "label-type": "job-profile"
                },
                on: { input: _vm.emitChangeEvent },
                model: {
                  value: _vm.careerLevels,
                  callback: function($$v) {
                    _vm.careerLevels = $$v
                  },
                  expression: "careerLevels"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.organisationalAreaEligible
        ? _c(
            "section",
            { staticClass: "tag" },
            [
              _c("h2", [
                _vm._v("In welchem Organisationsbereich ist die Tätigkeit?")
              ]),
              _vm._v(" "),
              _c("LockInfo", { staticClass: "mb-3" }),
              _vm._v(" "),
              _c("CharacteristicEdit", {
                attrs: {
                  title: "In welchem Organisationsbereich ist die Tätigkeit?",
                  "with-keyword": "",
                  "show-multiple-hint": "",
                  "characteristic-type": _vm.meta.organisationalAreaType,
                  "characteristic-items": _vm.organisationalAreaItems,
                  "label-type": "job-profile",
                  "open-fan-button-alignment": "left"
                },
                on: { input: _vm.emitChangeEvent },
                model: {
                  value: _vm.organisationalArea,
                  callback: function($$v) {
                    _vm.organisationalArea = $$v
                  },
                  expression: "organisationalArea"
                }
              })
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }